module.exports = __webpack_public_path__ + "img/quizmayhem_banner_sports.31fff9d0.jpg";